import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { mediaUrl } from "../lib/api";

export default function PageHero({ title, subtitle, image, crumb, photosPending = false }) {
  return (
    <section className="relative pt-20 lg:pt-28">
      <div className="relative h-[46vh] min-h-[340px] overflow-hidden">
        {photosPending ? (
          <div className="w-full h-full" style={{ background: "linear-gradient(135deg,#1480b3 0%,#0d5a80 100%)" }} />
        ) : (
          <img src={mediaUrl(image)} alt={title} loading="eager" fetchPriority="high" decoding="async" className="w-full h-full object-cover" />
        )}
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute inset-0 flex items-end">
          <div className="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 pb-10 lg:pb-14 text-shadow-hero">
            <nav className="flex items-center gap-1.5 text-white/80 text-xs mb-3 font-body">
              <Link to="/" className="hover:text-white">Accueil</Link>
              <ChevronRight size={13} />
              <span className="text-white">{crumb || title}</span>
            </nav>
            <h1 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight max-w-3xl">{title}</h1>
            {subtitle && <p className="mt-3 text-white/90 font-body text-base sm:text-lg max-w-2xl">{subtitle}</p>}
          </div>
        </div>
      </div>
    </section>
  );
}
